import React, { useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import styled, { css } from "styled-components";

const Editor = ({
  isMinimal = false,
  theme = "snow",
  value = "",
  onChange = () => {},
  placeholder,
  minHeight = 0,
  className,
  readOnly = false,
  ...rest
}) => {
  const ref = useRef();

  useEffect(() => {
    if (ref?.current !== undefined) {
      const element = ref.current?.editor?.root;
      if (element !== undefined) element.setAttribute("spellcheck", "false");
    }
  }, []);

  return (
    <Container
      minHeight={minHeight}
      className={className}
      isMinimal={isMinimal}
    >
      <ReactQuill
        ref={ref}
        theme={isMinimal ? null : theme}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        {...rest}
      />
    </Container>
  );
};


const Container = styled.div`
  .ql-editor {
    font-size: 1.1em;
    min-height: ${(props) => `${props.minHeight}px`};
  }

  ${(props) =>
    props.isMinimal &&
    css`
      .ql-editor {
        padding: 0 !important;
      }
    `}
`;

export default Editor;
